export enum NormalResultTypeEnum {
    Normal = 1,
    Abnormal = 2,
    Panic = 3,
    Absurd = 4,
}